module.exports = __webpack_public_path__ + "img/yanqi.5178ee0a.jpg";